import { Injectable } from '@angular/core';
import { GiftCardsAppConstants } from '@src/app/shared/constants/ib-gift-cards-constants';

@Injectable({
    providedIn: 'root'
})
export class IbGiftCardsRedirectionLandingService {

    constructor () { }

    redirection = (market: string, lang: string): void => {
        if (market !== 'ja' && market !== 'zh') {
            this.externalRedirect(`${window.location.origin}/${market}${GiftCardsAppConstants.LANDING_URL[lang]}`);
        } else {
            this.externalRedirect(`${window.location.origin}/${GiftCardsAppConstants.LANDING_URL[lang]}`);
        }
    };
    externalRedirect = (path: string):void => {
        window.location.href = path;
    };
}
